<template>
  <div class="products-page">
    <div class="page-header">
      <div class="container">
        <el-row>
          <h1 style="width: 100%">动态资讯</h1>
        </el-row>
        <el-row>
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>动态资讯</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-row>
      </div>
    </div>

    <div class="news-detail" v-if="selectedProduct.id">
      <div class="news-header">
        <h2>{{ selectedProduct.name }}</h2>
        <div class="news-meta">
          <span v-if="selectedProduct.dataForm" style="margin-right: 30px;" >来源：{{ selectedProduct.dataForm }}</span>
          <span class="news-date">日期：{{ selectedProduct.date }}</span>
        </div>
      </div>
      <div class="news-content">
        <div class="news-image">
        </div>
        <div class="news-text">
          <p  v-html="selectedProduct.shortDescription"></p>
        </div>
      </div>
      <div class="news-actions">
     
      </div>
    </div>
  </div>
</template>

<script>
import { productQY } from '@/views/DynamicQy.js'
import { productHY } from '@/views/DynamicHy.js'

export default {
  name: 'DynamicDetail',
  data() {
    return {
      selectedProduct: {},
    }
  },
  created() {
    // 获取路由参数中的产品ID
    const productId = this.$route.query.id
    if (productId) {
      // 合并所有产品数据
      const allProducts = [...productQY, ...productHY]
      // 根据ID查找产品
      this.selectedProduct = allProducts.find((product) => product.id == productId) || {}
    }
  },
  computed: {
    // formattedDescription() {
    //   // 将换行符 \n 转为 <br>，并处理多余的空格
    //   return this.selectedProduct.shortDescription
    //     .replace(/\n\s*\n/g, '</p><p>')  // 多个换行视为段落分隔
    //     .replace(/\n/g, '<br>')          // 单个换行为换行
    //     .replace(/<p><\/p>/g, '');       // 清理空段落
    // },
  },
  methods: {
    shareNews() {
      this.$message({
        message: '新闻分享功能已触发',
        type: 'success',
      })
    },
    downloadProductDoc() {
      this.$message({
        message: '产品资料下载中，请稍候...',
        type: 'success',
      })
    },
  },
}
</script>

<style scoped lang="scss">
// 新闻详情样式
.news-detail {
  margin: 0 auto;
  width: 1000px;

  .news-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;

    h2 {
      font-size: 25px;
      color: #333;
      letter-spacing: 2px;
      margin-bottom: 15px;
      font-weight: bold;
      text-align: center;
    }

    .news-meta {
      display: flex;
      color: #999;
      font-size: 14px;
      justify-content: center;
      .news-date {
        margin-right: 20px;
      }
    }
  }

  .news-content {
    margin-bottom: 30px;
    margin: 0 auto;
    width: 100%;
    .news-image {
      margin-bottom: 20px;
      text-align: center;

      img {
        width: 650px;
        height: 400px;
        border-radius: 4px;
      }
    }

    .news-text {
      color: #666;
      line-height: 1.8;
      font-size: 16px;
      text-indent: 2em; 
      p {
        margin-bottom: 80px;
      }
    }
  }

  // 手机端样式
  @media (max-width: 768px) {
    width: 95%;

    .news-header {
      h2 {
        font-size: 20px;
        letter-spacing: 1px;
      }

      .news-meta {
        flex-direction: column;
        align-items: center;
        gap: 5px;

        span {
          margin-right: 0 !important;
        }
      }
    }

    .news-content {
      width: 90%;

      .news-image {
        img {
          width: 85%;
          height: auto;
          max-height: 200px;
        }
      }

      .news-text {
        font-size: 14px;
        line-height: 1.6;
        text-indent: 1.5em;

        p {
          margin-bottom: 40px;
        }
      }
    }
  }

  .news-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
.page-header {
  background-image: url('/img/bg2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0;
  color: #fff;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 500;
    color: #fff;
  }

  .breadcrumb {
    margin-top: 10px;
    
    .el-breadcrumb {
      font-size: 14px;
      
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(255, 255, 255, 0.8);
          
          &:hover {
            color: #fff;
          }
        }
        
        &:last-child {
          .el-breadcrumb__inner {
            color: #fff;
          }
        }
      }
    }
  }
}

</style>

<style scoped>
:deep(.news-text img) {
  max-width:100% !important;
  height: auto !important;
  display: block;
  margin: 20px auto;
  border-radius: 4px;
}

:deep(.news-text p) {
  color: #666;
  font-size: 16px;
}
</style>
